"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18nDefaultValues = void 0;
exports.i18nDefaultValues = {
    CoverageSum: {
        title: 'Выплатим в случае',
        coverageTitle: 'Выберите сумму выплаты',
        coverageSubTitle: 'Максимальная выплата по каждому застрахованному',
        modalTitle: 'Как выбрать страховую сумму \nпокрытия?',
        buttons: {
            howToChooseCoverageSum: 'Как выбрать сумму?',
            everythingIsClear: 'Понятно',
        },
        hints: {
            rules: 'Максимальная выплата за каждую пострадавшую вещь составляет 10% от страховой суммы. Чтобы обеспечить достаточное страховое покрытие, мы рекомендуем выбирать сумму с учетом этого правила',
            amount: 'Размер выплаты зависит от конкретного типа травмы и определяется как % от максимальной суммы согласно таблице выплат.',
            recomendations: 'Мы рекомендуем выбирать страховую сумму от 500 000 рублей, чтобы выплата компенсировала расходы на лечение.',
            example: 'Примеры выплат по наиболее распространненым травмам:',
            other: 'Выплаты также предусмотрены при повреждении нервной системы, сердечно-сосудистой системы, обморожении и других видах травм',
            full: 'Полный перечень травм и выплат перечислен в <a target="_blank" href="{{href}}">правилах страхования</a>',
        },
        events: {
            title: 'Событие',
            amount: 'Выплаты при страховой сумме\u00A0500\u00A0000\u00A0₽',
            brokenNose: 'Перелом носа',
            rightArm: 'Разрыв сухожилия правой руки',
            brain: 'Сотрясение мозга, лечение 14 дней',
            wrist: 'Вывих кисти',
            boneFracture: 'Перелом плечевой кости',
            hipFracture: 'Перелом шейки бедра',
            disability3: 'Инвалидность III группа',
            disability2: 'Инвалидность I,II группа',
        },
    },
};
